import {
	GET_ALL_ITCONTROLS,
	GET_ITCONTROL_BY_ID,
	UPDATE_ITCONTROL,
	CREATE_ITCONTROL,
	DELETE_ITCONTROL,
	GET_ENGAGEMENT_ALL_ITCONTROLS,
	REFRESH_UNRELATED_ITCONTROLS
} from '../actiontypes';
import {
	API_RESOURCES,
	createApiCreateAction,
	createApiReadAction,
	createApiUpdateAction,
	createApiDeleteAction
} from '../../util/api';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {getQueryString} from '../apiUrls';

export const getITControlById = (engagementId, itcontrolId, documentId) => {
	const queryString = getQueryString({documentId});
	const url = `${env.getBaseURL(serviceURL, engagementId)}ITControls/${itcontrolId}${queryString}`;

	return {
		type: GET_ITCONTROL_BY_ID,
		resolve: true,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const deleteITControl = (engagementId, itControlId, bodyId, isUnrelated) => {
	return createApiDeleteAction(
		DELETE_ITCONTROL,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITCONTROL]: itControlId
		},
		{itControlId, bodyId, isUnrelated}
	);
};

export const updateITControl = (engagementId, itcontrolId, data) => {
	return createApiUpdateAction(
		UPDATE_ITCONTROL,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITCONTROL]: itcontrolId
		},
		data,
		undefined,
		{resolve: true}
	);
};

export const createITControl = (engagementId, data, itProcessId) => {
	return createApiCreateAction(
		CREATE_ITCONTROL,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITCONTROL]: undefined
		},
		data,
		{itProcessId}
	);
};

export const getAllItControls = (engagementId, filters, actionProps, trackWithArea) => {
	return createApiReadAction(
		GET_ALL_ITCONTROLS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITCONTROL]: undefined
		},
		filters,
		actionProps,
		undefined,
		trackWithArea
	);
};

export const getEngagementAllItControls = (engagementId, actionProps, filters) => {
	return createApiReadAction(
		GET_ENGAGEMENT_ALL_ITCONTROLS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITCONTROL]: undefined
		},
		filters,
		{...actionProps, resolve: true}
	);
};

export const getAllUnrelatedItControls = (engagementId, filters, actionProps, trackWithArea) => {
	const _filters = {
		...filters,
		IsUnrelated: true
	};
	return getAllItControls(engagementId, _filters, actionProps, trackWithArea);
};

export function refreshUnrelatedItControls(bodyId) {
	return {
		type: REFRESH_UNRELATED_ITCONTROLS,
		bodyId
	};
}
